import { Button, Icon } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import type { OrderBoxModeSwitchProps } from './order-box.types'

export const OrderBoxModeSwitch = ({
  mode,
  onChange,
}: OrderBoxModeSwitchProps) => {
  const { t } = useTranslate()
  const isOrder = mode === 'order'
  return (
    <Button
      type='button'
      className='w-fit'
      endIcon={<Icon name='TriangleDown' />}
      onClick={() => onChange(isOrder ? 'easy' : 'order')}
      variant='transparent'
      color='neutral'
    >
      {isOrder ? t('order_order') : t('order_easy')}
    </Button>
  )
}
